import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { combinedUrls } from "../../../URL/functions";
import { ftlRouteUrls, projectUrls } from "../../../URL/ApplicationUrls";
import { UppercaseButton } from "../../../Layout/Buttons/UppercaseButton";
import { KENDO_BUTTON_CLASSES } from "../../../Layout/Buttons/KendoButtons";
import { IconWithRightMargin } from "../../../Layout/Icons/IconWithRightMargin";
import { useExportWithToast } from "../../../Grid/ExcelExport/useExportWithToast";

async function getFtlRouteIds(projectId: number): Promise<Array<number>> {
  const url = combinedUrls(projectUrls.base.apiUrl, `${projectId}/FtlRouteIds`);
  const response = await axios.get(url);
  return response.data;
}

export default function ExportRasButton({ selectedProjectId }: { selectedProjectId: number }) {
  const exportRasWithToast = useExportWithToast(
    (routeId: number | undefined) =>
      axios.get(combinedUrls(ftlRouteUrls.base.apiUrl, `${routeId}/ExportRas`), {
        responseType: "blob",
      }),
    "Exporting RAS"
  );

  const exportRas = async () => {
    const ftlRouteIds = await getFtlRouteIds(selectedProjectId);
    if (ftlRouteIds.length > 0) {
      //  eslint-disable-next-line no-restricted-syntax
      for await (const routeId of ftlRouteIds) {
        await exportRasWithToast(routeId);
      }
    } else toast.error("No Routes added to Project, RAS cannot be created");
  };

  return (
    <UppercaseButton
      type="button"
      title="Export RAS"
      className={KENDO_BUTTON_CLASSES}
      onClick={() => exportRas()}
      disabled={!selectedProjectId}
    >
      <IconWithRightMargin icon={faUpRightFromSquare} />
      Export RAS
    </UppercaseButton>
  );
}
